import React from 'react';
import styled from 'styled-components';
import TextBlock from '@component/common/block/text-block';
import Gap from '@component/common/gap';
import TextButton from '@design-system/text-button';
import * as color from '@constant/color';
import { ETheme } from '@datatype/type';
import * as size from '@constant/size';

interface IProps {
  title: string;
  description?: string;
  errorMessage?: string;
  isPending: boolean;
  confirmText?: string;
  confirmTheme?: ETheme;
  handleCancel: () => void;
  handleRemove: () => void;
}

const Wrapper = styled.div`
  display: flex;
  width: ${size.MEDIUM_MODAL_WIDTH};
  flex-direction: column;
`;

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  gap: ${size.MARGIN_1};
`;

const RemoveModalTemplate: React.FC<IProps> = ({
  title,
  description,
  errorMessage,
  isPending,
  confirmText = '삭제',
  confirmTheme = ETheme.RED,
  handleCancel,
  handleRemove,
}) => (
  <Wrapper>
    <TextBlock text={title} design={{ text: { size: 'large', color: color.BLACK_2, bold: true } }} />
    {description && (
      <>
        <Gap height={size.MARGIN_1} />
        <TextBlock text={description} design={{ text: { size: 'medium', color: color.GRAY_1 } }} />
      </>
    )}
    {errorMessage && (
      <>
        <Gap height={size.MARGIN_1} />
        <TextBlock text={errorMessage} design={{ text: { size: 'small', color: color.RED_2 } }} />
      </>
    )}
    <Gap height={size.MARGIN_2} />
    <ButtonContainer>
      <TextButton
        text='취소'
        theme={ETheme.GRAY}
        kind='outlined'
        size='medium'
        shape='pill'
        width='100%'
        disabled={isPending}
        handleClick={handleCancel}
      />
      <TextButton
        text={confirmText}
        theme={confirmTheme}
        size='medium'
        shape='pill'
        width='100%'
        disabled={isPending}
        isLoading={isPending}
        handleClick={handleRemove}
      />
    </ButtonContainer>
  </Wrapper>
);

export default RemoveModalTemplate;
